export const CUT_MODES = {
  CUT: "cut",
  CUT_OFF_RIGHT: "cut_off_right",
  CUT_OFF_LEFT: "cut_off_left",
  CUT_OFF_TRACK: "cut_off_track",
  CUT_SUPERTRACK: "cut_supertrack",
};

// export const PIPELINE_OPTIONS = [
//   { label: "Advanced", value: "advanced" },
//   { label: "Player Highlights", value: "player_highlights" },
//   { label: "Team Highlights", value: "team_highlights" },
//   { label: "Light", value: "light" },
//   { label: "Advanced DRAW", value: "advanced_draw" },
//   { label: "Team analytics pro tagging", value: "team_analytics_pro_tagging" },
// ];

export const PIPELINE_OPTIONS = [
  { value: "player_analytics", label: "Player analytics" },
  { value: "team_analytics", label: "Team analytics" },
  { value: "team_analytics_pro", label: "Team analytics pro" },
  { value: "team_analytics_pro_draw", label: "Team analytics pro draw" },
  { value: "match_analytics", label: "Match analytics" },
  { value: "match_analytics_pro", label: "Match analytics pro" },
  { value: "training_analytics", label: "Training analytics" },
  { value: "broadcasting", label: "Broadcasting" },
  { value: "broadcasting_draw", label: "Broadcasting draw" },
];